<template>
  <div class="card commodity-info">
    <div class="info">
      <div class="info-header">{{title}}</div>
      <van-row class="info-line" type="flex" align="center">
        <van-col :span="5">
          <div class="info-title">付款方式：</div>
        </van-col>
        <van-col :span="19">
          <div class="info-value">
            <van-radio-group v-model="deliveryType" direction="horizontal">
              <van-radio name="1">管输</van-radio>
            </van-radio-group>
          </div>
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderDeliveryTypeCard",
  props: {
    title: {
      type: String,
      default: "交货方式",
    },
  },
  data() {
    return {
      deliveryType: "1",
    };
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';

.card {
  margin-top: 24px;
  background: #ffffff;
  padding: 0 24px;
  font-size: 26px;

  .info {
    padding: 16px 0;

    .info-header {
      display: flex;
      justify-content: right;
      align-items: center;
      height: 88px;
      font-size: 32px;

      img {
        width: 40px;
        height: 40px;
        margin-right: 12px;
      }
    }

    .info-line >>> .van-radio {
      .van-radio__icon {
        font-size: 24px;
      }

      .van-radio__label {
        line-height: 54px;
      }
    }

    .info-line {
      line-height: 54px;
      color: #666666;
    }
  }
}
</style>